module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.userId) ? _c('modal', {
    attrs: {
      "closeCrossColor": "#ccc"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "events__modal text-dark",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "events__modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('h3', [(_vm.eventsFilter === 'absence') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.absence')))]) : _vm._e(), _vm._v(" "), (_vm.eventsFilter === 'subject') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.teaching')))]) : _vm._e(), (_vm.eventsFilter === 'substituteHours') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.substitute_hours')))]) : _vm._e(), _vm._v("  " + _vm._s(_vm.$t('vue2.user_event_list.from')) + " " + _vm._s(_vm._f("LL")(_vm.start)) + " " + _vm._s(_vm.$t('vue2.user_event_list.to')) + " " + _vm._s(_vm._f("LL")(_vm.end)))])]), _vm._v(" "), _c('div', {
    staticClass: "events__modal__body"
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": "#f6f9fc"
    }
  }) : [(_vm.filteredEvents.length < 1) ? _c('h4', {
    staticClass: "text--explainer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.no_matching_events')))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "events__list"
  }, [_vm._l((_vm.sortedEvents), function(event) {
    return _c('li', {
      key: event.event_id
    }, [_c('p', [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("ddd")(event.start_time))) + " " + _vm._s(_vm._f("LL")(event.start_time)) + " kl. " + _vm._s(_vm._f("LT")(event.start_time)) + " -\n              " + _vm._s(_vm._f("LT")(event.end_time)) + ", " + _vm._s(event.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDuration(event)))])])
  }), _vm._v(" "), _c('li', [_c('b', [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.total')))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.totalDuration))])])], 2)]], 2), _vm._v(" "), _c('div', {
    staticClass: "events__modal__footer"
  }, [_c('button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.user_event_list.close')))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64023200!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserEventList.vue
// module id = 1634
// module chunks = 1